import React, {useEffect, useState} from 'react';
import s from './BankTransfer.module.css'
import BankTransferStepOne from "./BankTransferStepOne/BankTransferStepOne";
import BankTransferStepTwo from "./BankTransferStepTwo/BankTransferStepTwo";

const BankTransfer = () => {

    const [current, setCurrent] = useState(0);
    const [transferData, setTransferData] = useState({})

    useEffect(() => {
        return () => {
            sessionStorage.removeItem('transfer-form');
        }
    },[]);

    const steps = [
        {
            content: <BankTransferStepOne setCurrent={setCurrent}
                                          current={current}
                                          setTransferData={setTransferData}
            />
        },
        {
            content: <BankTransferStepTwo setCurrent={setCurrent}
                                          current={current}
                                          transferData={transferData}
            />
        },
    ];

    return (
        <div className={s.wrapper}>
            {steps[current].content}
        </div>
    );
};

export default BankTransfer;
